import {Component, forwardRef} from '@angular/core';
import {FormBuilder, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {LegalCaseStateService} from '../../../core/services/legal-case-state.service';
import {AbstractControlComponent} from "../../abstract-control-value-accessor/abstract-control.component";
import {ISimpleSelectableDataList} from "../../model/interface/simple-selectable-data.model.interface";

@Component({
  selector: 'app-search-state',
  templateUrl: './search-state.component.html',
  styleUrls: ['./search-state.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchStateComponent),
      multi: true,
    },
  ],
})
export class SearchStateComponent extends AbstractControlComponent {
  stateForm: FormControl;
  states: ISimpleSelectableDataList;

  constructor(private formBuilder: FormBuilder,
              private legalCaseStateService: LegalCaseStateService) {
    super();
    this.createForm();
  }

  ngOnInit(): void {
    this.fetchStates();
  }

  private fetchStates() {
    this.legalCaseStateService.getAllStatesAvailableForSearchQuery()
      .subscribe((data) => this.states = data.toSimpleSelectableDataList());
  }

  private createForm() {
    this.stateForm = this.formBuilder.control([]);
  }

  registerOnChange(fn: any): void {
    this.stateForm.valueChanges.subscribe(fn);
  }



  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.stateForm.disable() : this.stateForm.enable();
  }

  writeValue(obj: any): void {
    if (obj == null) {
      this.stateForm.reset();
    } else {
      this.stateForm.setValue(obj);
    }
  }

  clear() {
    this.stateForm.reset();
  }
}
